import { render, staticRenderFns } from "./TurnoverStatusCard.vue?vue&type=template&id=818306fe&scoped=true&"
import script from "./TurnoverStatusCard.vue?vue&type=script&lang=js&"
export * from "./TurnoverStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./TurnoverStatusCard.vue?vue&type=style&index=0&id=818306fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818306fe",
  null
  
)

export default component.exports